import { FeatureService } from "@areahub/arcgis";
import { useCallback, useRef } from "react";
import { FeatureServiceOptions } from "./use-feature-service";

export const useMultiFeatureServices = (
  feats: FeatureServiceOptions[],
  deps: any[] = [],
  layers?: any[],
) => {
  const ref = useRef<any>(null);

  const onLoad = useCallback(() => {
    const fss = feats.map((feat) => {
      const fs = new FeatureService(
        feat.layer.source,
        ref?.current?.getMap(),
        {
          url: feat.url,
          ...feat.arcgisOptions,
        },
        feat?.geojsonSourceOptions,
      );
      return fs;
    });
    feats.map((fs) => ref.current?.getMap().addLayer(fs.layer));
    if (layers) {
      layers?.map((l) => ref.current?.getMap().addLayer(l));
    }
  }, [feats, layers, ...deps]);

  return {
    onLoad,
    ref,
  };
};
